import React from 'react';

import { Box } from '@mui/material';

import './styles.scss';

const OlcToggle = ({
  checked = false,
  onChange,
  disabled = false,
  ariaLabel = 'Toggle',
  className = '',
}) => {
  const handleToggle = () => {
    if (disabled) return;
    onChange?.(!checked);
  };

  const handleKeyDown = (event) => {
    if (disabled) return;
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleToggle();
    }
  };

  return (
    <Box
      className={`olcToggleWrapper ${checked ? 'enabled' : ''} ${
        disabled ? 'isDisabled' : ''
      } ${className}`.trim()}
      onClick={handleToggle}
      onKeyDown={handleKeyDown}
      role="switch"
      aria-checked={checked}
      aria-label={ariaLabel}
      tabIndex={disabled ? -1 : 0}
    >
      <Box className="toggle-track">
        <Box className="toggle-thumb" />
      </Box>
    </Box>
  );
};

export default OlcToggle;
